import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { GenericHero, HeroWithRichText, StoreHero } from "./variants";
export var Hero = function(param) {
    var heroProps = param.heroProps;
    switch(heroProps === null || heroProps === void 0 ? void 0 : heroProps.component){
        case "GenericHero":
            return /*#__PURE__*/ _jsx(GenericHero, _object_spread({}, heroProps));
        case "CarFinanceHero":
            return /*#__PURE__*/ _jsx(HeroWithRichText, _object_spread({}, heroProps));
        case "StoreHero":
            return /*#__PURE__*/ _jsx(StoreHero, _object_spread({}, heroProps));
        default:
            return null;
    }
};
